module.exports = __webpack_public_path__ + "static/media/meenakshi.e1370dcf.jpg";